import React, { useState } from "react";
import AdminNavBar from "../AdminNavBar";
import NavLogo from "../NavLogo";
import { Row, Col,Button,Table, Spinner  } from "react-bootstrap";
import ReportNavbar from "./ReportNavbar";
import { Autocomplete, TextField } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { DeliveryStockADD, ReturnStockAdd } from "../../Admin/API/Api";
import axios from 'axios'
import { MDBDataTable } from 'mdbreact';
import { toast } from 'react-toastify';
import DailyStock from './../../Admin/AdminMaster/AdminOrderDS/DailyStock';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import html2pdf from "html2pdf.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ReportReturnStock = () => {

    const userdata = JSON.parse(sessionStorage.getItem('userdata')) || {};
    let { branch_id: branchId, branch_name: Name, mrbranch_name: MarathiName } = userdata;
    const selectedLanguage = sessionStorage.getItem('selectedLanguage');
    const displayName = selectedLanguage === 'Marathi' ? MarathiName : Name;

    const [date, setDate] = useState(null);
    const [selectedOption, setSelectedOption] = useState('');
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);

    const savedata = () => {
        setLoading(true);
        if (!date || !selectedOption) {
            toast.error("Please select both date and option before saving", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return;
        }
        setTableData([]);

        const formattedDate = dayjs(date).format('DD/MM/YYYY');
        const data = {
            date: formattedDate,
            branch_id: branchId, 
            flag: parseInt(selectedOption)
        };
        console.log("obj console......", data);
    
        axios.post(ReturnStockAdd, data)
            .then(response => {
                console.log("response.data", response);
                setTableData(response.data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message === "No data found") {
                    toast.info("Data Not Found ..!", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setLoading(false);
                } else {
                    console.error("Error while fetching data from backend:", error);
                    setLoading(false);
                }
            });
    };

    const rows = [];
    let srNo = 1;
    Object.keys(tableData).forEach((employeeName) => {
        tableData[employeeName].forEach((item) => {
            rows.push({
                'Sr. No': srNo,
                'Date': item.date,
                'Employee Name': employeeName,
                'Product': item.product,
                'Quantity': item.quantity
            });
            srNo++;
        });
    });
    
    const data = {
        columns: [
            {
                label: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'),
                field: 'Sr. No'
            },
            {
                label: (selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'),
                field: 'Date'
            },
            {
                label: (selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'),
                field: 'Employee Name'
            },
            {
                label: (selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'),
                field: 'Product'
            },
            {
                label: (selectedLanguage === 'Marathi' ? 'संख्या' : 'Quantity'),
                field: 'Quantity'
            }
        ],
        rows: rows
    };

    // const generatePDF = () => {
    //     setLoading(true);
    //     if (rows.length === 0) {
    //         toast.error("No data available to generate PDF", {
    //             position: "top-right",
    //             autoClose: 3000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //         });
    //         setLoading(false);
    //         return;
    //     }
    
    //     const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    //     const branchName = userdata.branch_name;
    
    //     let selectedText = '';
    //     if (selectedOption === '1') {
    //         selectedText = 'Daily Stock';
    //     } else if (selectedOption === '2') {
    //         selectedText = 'Return Stock';
    //     } else if (selectedOption === '3') {
    //         selectedText = 'Breakage Stock';
    //     }
    
    //     const docDefinition = {
    //         content: [
    //             {
    //                 stack: [
    //                     { text: branchName, style: 'branchName' },
    //                     { text: `Report: ${selectedText}`, style: 'selectedOption' }, // Display selected option
    //                     { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1 }] }, // Horizontal line
    //                     { text: ' ', margin: [0, 0, 0, 10] }, // Add space for separation
    //                 ]
    //             },
    //             {
    //                 table: {
    //                     headerRows: 1,
    //                     widths: ['auto','auto', '*', '*', 'auto'],
    //                     body: [
    //                         [
    //                             { text: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'), style: 'tableHeader' },
    //                             { text: (selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'), style: 'tableHeader' },
    //                             { text: (selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'), style: 'tableHeader' },
    //                             { text: (selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'), style: 'tableHeader' },
    //                             { text: (selectedLanguage === 'Marathi' ? 'संख्या' : 'Quantity'), style: 'tableHeader' }
    //                         ],
    //                         ...rows.map(row => [row['Sr. No'],row['Date'], row['Employee Name'], row['Product'], row['Quantity']])
    //                     ],
    //                     layout: {
    //                         defaultBorder: false
    //                     }
    //                 }
    //             }
    //         ],
    //         footer: function(currentPage, pageCount) {
    //             return {
    //                 text: 'Developed By : TechnoAarv Solution',
    //                 alignment: 'center',
    //                 fontFamily: 'Roboto',
    //                 fontSize: 8,
    //             };
    //         },
    //         styles: {
    //             branchName: { fontSize: 22, bold: true, alignment:"center", margin: [0, 5, 0, 25] },
    //             selectedOption: { fontSize: 14, bold: true, margin: [0, 0, 0, 5] },
    //             tableHeader: { bold: true, fontSize: 12, color: 'black', fillColor: '#87b2b2' } 
    //         }
    //     };
    //     pdfMake.createPdf(docDefinition).open();
    //     setLoading(false);
    // };
    

    const generatePDF = async () => {
        setLoading(true);
        if (rows.length === 0) {
            toast.error("No data available to generate PDF", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }
        
        const element = document.getElementById("pdf-content");
      
        element.style.display = "block";
      
        await new Promise(resolve => setTimeout(resolve, 2000));
      
        const options = {
          margin: 10,
          filename: 'generated.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };
      
        html2pdf()
          .set(options)
          .from(element)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            const blobUrl = URL.createObjectURL(pdf.output("blob"));
            element.style.display = "none";
      
            window.open(blobUrl, "_blank");
      
            setLoading(false);
      
            toast.success("PDF generated successfully.");
          })
          .catch((error) => {
            console.error("Error generating PDF:", error);
            setLoading(false);
            toast.error("Error generating PDF");
          });
      };

      let selectedText = '';
      if (selectedOption === '1') {
          selectedText = (selectedLanguage === 'Marathi' ? 'दैनिक स्टॉक' : 'Daily Stock');
      } else if (selectedOption === '2') {
          selectedText = (selectedLanguage === 'Marathi' ? 'स्टॉक परत केलेला' : 'Return Stock');
      } else if (selectedOption === '3') {
          selectedText = (selectedLanguage === 'Marathi' ? 'ब्रेकेज स्टॉक' : 'Breakage Stock');
      }

  return (
    <div>
            <AdminNavBar />
            <section className="home-section">
                <NavLogo />
                <ReportNavbar />

                <Row className="m-0 p-0 pt-4 px-md-4 px-2">
                    <Col
                        className=" rounded text-center pt-2"
                        style={{
                            display: "flex",
                            justifyContent: "start",
                            backgroundColor: "white",
                            border: "0px",
                            alignItems: "center",
                            alignContent: "center",
                            color: " rgb(47, 79, 79)",
                        }}
                    >
                        <h5>{selectedLanguage === 'Marathi' ? 'अवितरित अहवाल' : 'Undelivery Report'}</h5>
                    </Col>
                </Row>


                <Row className="m-0  py-3 px-2 mx-md-3 rounded">
                    <Col className="m-0 p-0 py-2  pb-3 rounded" style={{ background: "white" }}>
                        <Row
                            className="m-0 p-0"
                        >
                            <Col sm={12} md={3} >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={["DatePicker"]}>
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            label={selectedLanguage === 'Marathi' ? 'तारीख निवडा' : 'Select Date'}
                                            value={date}
                                            onChange={(newDate) => {
                                                console.log("date res", newDate);
                                                setDate(newDate);
                                            }}
                                            slotProps={{ textField: { size: "small" } }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Col>

                            <Col sm={12} md={3} className="mt-2">
                                <TextField
                                    id="demo-simple-select"
                                    size="small"
                                    label={selectedLanguage === 'Marathi' ? 'पर्याय निवडा' : 'Select Option'}
                                    select
                                    value={selectedOption}
                                    onChange={(e) => setSelectedOption(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                    SelectProps={{
                                        native: true,
                                    }}
                                >
                                    <option value="" disabled></option>
                                    <option value='1'>{selectedLanguage === 'Marathi' ? 'दैनिक साठा' : 'Daily Stock'}</option>
                                    <option value='2'>{selectedLanguage === 'Marathi' ? 'साठा परत केलेला' : 'Return Stock'}</option>
                                    <option value='3'>{selectedLanguage === 'Marathi' ? 'ब्रेकेज साठा' : 'Breakage Stock'}</option>
                                </TextField>
                            </Col>

                            <Col sm={12} md={3} className="mt-2">
                                <Button
                                    style={{
                                        border: "0px",
                                        backgroundColor:
                                            "rgb(47, 79, 79)",
                                        fontSize: "17px",
                                        color: "white",
                                        borderRadius: "15px",
                                    }}
                                    className="buttonAll py-2 px-3 mx-2 shadow "
                                    type="submit"
                                    onClick={savedata}
                                >
                                   {selectedLanguage === 'Marathi' ? 'माहिती बघा' : 'Show Data'}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* Display table with fetched data */}
                <Row className="m-0 pt-1 px-2 mx-md-3 mb-3 rounded">
      <Col className="m-0 p-0 px-3 py-3 rounded" style={{ background: "white" }}>
      <Col style={{display:"flex",justifyContent:"end"}}>
                    <button
                                className=' button-30'
                                disabled={loading}
                                onClick={generatePDF}
                            >
                                {loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>{selectedLanguage === 'Marathi' ? 'पीडीएफ निर्यात करा' : 'Export Pdf'}</div>}  
                                </button>
                    </Col>
    <MDBDataTable
        striped
        className='custom-datatable'
        bordered
        hover
        data={data}
    />
    </Col>
</Row>

<div className="px-4" id="pdf-content"  style={{fontSize:"16px",fontFamily: "'Gotu', sans-serif",
fontFamily: "'Noto Sans Devanagari', sans-serif",display: "none"}}>

<div className="row">
  <div className="col-md-12">
        <div className="text-center fs-2 bold">{displayName}</div>
</div>
</div>

<div className="row">
  <div className="col-md-12">
        <div className="fs-5 bold pb-2" style={{borderBottom:"1px solid black"}}>{selectedLanguage === 'Marathi' ? 'अहवाल' : 'Report'}:  { selectedText}</div>
</div>
</div>

<Table striped bordered hover size="sm" className='rounded mb-3 mt-4' style={{textAlign:"center",border:"1px solid black"}}>
    <thead>
        <tr>
            <th style={{alignItems:"center", backgroundColor:"rgb(230, 237, 234)", border:"1px solid black", fontSize:"13px", fontFamily:"sans-serif"}} className='text-center text-dark'>
                {selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'}
            </th>
            <th style={{alignItems:"center", backgroundColor:"rgb(230, 237, 234)", border:"1px solid black", fontSize:"13px", fontFamily:"sans-serif"}} className='text-center text-dark'>
                {selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'}
            </th>
            <th style={{alignItems:"center", backgroundColor:"rgb(230, 237, 234)", border:"1px solid black", fontSize:"13px", fontFamily:"sans-serif"}} className='text-center text-dark'>
                {selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'}
            </th>
            <th style={{alignItems:"center", backgroundColor:"rgb(230, 237, 234)", border:"1px solid black", fontSize:"13px", fontFamily:"sans-serif"}} className='text-center text-dark'>
                {selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'}
            </th>
            <th style={{alignItems:"center", backgroundColor:"rgb(230, 237, 234)", border:"1px solid black", fontSize:"13px", fontFamily:"sans-serif"}} className='text-center text-dark'>
                {selectedLanguage === 'Marathi' ? 'संख्या' : 'Quantity'}
            </th>
        </tr>
    </thead>
    <tbody>
        {data.rows.map((item, index) => (
            <tr key={index} style={{fontSize:"14px"}}>
                <td style={{ textAlign:"center", border:"1px solid black"}}>{item['Sr. No']}</td>
                <td style={{ textAlign:"center", border:"1px solid black"}}>{item['Date']}</td>
                <td style={{ textAlign:"center", border:"1px solid black"}}>{item['Employee Name']}</td>
                <td style={{ textAlign:"center", border:"1px solid black"}}>{item['Product']}</td>
                <td style={{ textAlign:"center", border:"1px solid black"}}>{item['Quantity']}</td>
            </tr>
        ))}
    </tbody>
</Table>

</div>


            </section>
        </div>
  );
};
export default ReportReturnStock;


